import { withStyle, Text5 } from '@olxeu-jobs/ui';
import { FormattedMessage } from '~i18n';

const Hint = withStyle(Text5, ({ $theme }) => ({
  color: $theme.colors['text-global-secondary'],
}));

export const CropperHint = () => (
  <Hint>
    <FormattedMessage
      id="comp.cropper.hint"
      defaultMessage="Drag frame to reposition and crop the image"
    />
  </Hint>
);
